<template>
  <div class="bg-white">
    <header class="absolute inset-x-0 top-0 z-50">
      <nav class="flex items-center justify-between p-6 lg:px-8" aria-label="Global">
        <div class="flex lg:flex-1">
          <a href="#" class=" p-1.5">
            <span class="sr-only">
              St. Audio Studio
            </span>
            <img class="h-11" src="/images/studio.svg" alt="St. Audio Studio" />
          </a>
        </div>
        <div class="flex flex-1 justify-end">
          <router-link :to="{name: 'setup'}" class="text-sm font-semibold leading-6 text-gray-900 mr-6">
            Kostenlos registrieren
          </router-link>
          <router-link :to="{name: 'login'}" class="text-sm font-semibold leading-6 text-gray-900">
            Studio öffnen
          </router-link>
        </div>
      </nav>
    </header>
  </div>
</template>
